import IndexDB from '@/assets/js/indexDB.js'
import { Message } from 'element-ui'

const state = {
   databaseName: 'callCat',
   tableName: 'callList',
   callCatStatus: false,
   callNum: 0,
   callList: [],

   // PHONE_CAT: null, // 电话猫推送
   // isCompanayPhoneCat: [], // 当前公司的电话猫设备号

   wsuri: 'ws://127.0.0.1:823' // 电话猫连接地址
   // wsuri: 'ws://localhost?sid=789&pid=84529FA7-7195-4541-AA38-B22003CCFF4D&flag=1' // 电话猫连接地址
}

const getters = {
   callCatStatusGetter: state => state.callCatStatus,
   callNumGetter: state => state.callNum,
   callListGetter: state => state.callList,
}


var websock = null;
const mutations = {
   // ISCOMPHON_CAT(state, obj) {
   //    state.isCompanayPhoneCat = obj;
   // },
   WS_connect(state) {
      // console.log('电话猫websoket链接成功')
      websock = new WebSocket(state.wsuri)
      websock.onmessage = function (e) { websocketonmessage(e) };

      websock.onopen = async (e) => {
         // Message({
         //    message: '电话猫已连接',
         //    type: 'success'
         // })

         let res = await IndexDB.allIDB(state.databaseName, state.tableName);
         let lastCallTime = sessionStorage.getItem('lastCallTime');
         let callNum = 0;
         res.map(item => {
            if (item.time > Number(lastCallTime)) {
               callNum++;
            }
         })
         res.sort((a, b) => {
            return b.time - a.time
         })
         state.callNum = callNum;
         state.callList = res;
         console.log('查询的表数据：', res);
      }

      websock.onclose = (e) => {
         // Message({
         //    message: '电话猫连接已关闭',
         //    type: 'warning'
         // })
      }

      websock.onerror = (e) => {
         // Message({
         //    message: '电话猫连接发生错误，请检查网络环境',
         //    type: 'warning'
         // })
      }
   },
   WS_close() {
      websock.close()
   },
   async WS_deleteData(state, data) {
      await IndexDB.deleteIDB(state.databaseName, state.tableName, data);
      let res = await IndexDB.allIDB(state.databaseName, state.tableName);
      let lastCallTime = sessionStorage.getItem('lastCallTime');
      let callNum = 0;
      res.map(item => {
         if (item.time > Number(lastCallTime)) {
            callNum++;
         }
      })
      res.sort((a, b) => {
         return b.time - a.time
      })
      state.callNum = callNum;
      state.callList = res;
      console.log('查询的表数据：', res);
   },

   callNum_U(state, data) {
      if (data != state.callNum) {
         state.callNum = data;
      }
   }
}

// 数据接收
async function websocketonmessage(e) {
   let data = JSON.parse(e.data);
   console.log('接受', data);
   if (data.type == 505) {
      let phone = data.data.lParam.toString();
      let time = new Date().getTime();
      data = { time, phone };
      await IndexDB.addIDB(state.databaseName, state.tableName, data);
      let res = await IndexDB.allIDB(state.databaseName, state.tableName);
      let lastCallTime = sessionStorage.getItem('lastCallTime');
      let callNum = 0;
      res.map(item => {
         if (item.time > Number(lastCallTime)) {
            callNum++;
         }
      })
      res.sort((a, b) => {
         return b.time - a.time
      })
      state.callNum = callNum;
      state.callList = res;

      console.log('查询的表数据：', res);
   }
}

export default {
   name: 'callCat',
   state,
   getters,
   mutations
}
